import React from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Services/AxiosAPICaller";
import { IContactGroups } from "../../Interfaces/IContactsGroups";
import BackBtn from "../BackButton/BackButton";
import "./ContactGroupDetail.css";

const BubbleDetail: React.FC = () => {
  const { Id } = useParams<{ Id: string }>();
  const [ContactGroup, setContactGroup] = React.useState<IContactGroups | null>(
    null
  );

  React.useEffect(() => {

    axiosInstance
      .get<{ data: { id: number; attributes: any } }>(
        `/groupes-de-contacts/${Id}?populate[Image][fields][1]=url`
      )
      .then((response) => {

        const item = response.data.data;

        // Create Bubble Object From API returned Datas
        const ContactGroup: IContactGroups = {
          Id: item.id,
          Name: item.attributes.Nom,
          Description: item.attributes.Description ?? null,
          Image: item.attributes.Image?.data?.attributes?.url || "",
          Bubble: item.attributes.bulle ?? null,
          Contacts: item.attributes.groupes_de_contacts ?? null,
        };

        setContactGroup(ContactGroup);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération du groupe de contact:",
          error
        );
      });
  }, [Id]);

  if (!ContactGroup)
    return <p>Chargement des infos de groupes de contacts...</p>;

  return (
    <div className="TitleContainer">
      {ContactGroup.Image && (
        <img
          src={ContactGroup.Image}
          alt={ContactGroup.Name}
          style={{ width: "100%" }}
        />
      )}
      <BackBtn></BackBtn>
      <h1 className="OpenedContactGroupName">{ContactGroup.Name}</h1>
      <p className="OpenedContactGroupDesc">{ContactGroup.Description}</p>
    </div>
  );
};

export default BubbleDetail;
